import useElementDimensions from "../../misc/useElementDimensions";
import { useEffect, useState } from "react";
import { getColumns } from "./columns";
import type { ParticipantListRequiredFields } from "./participantListApi";

export const useColumns = (requiredFields: ParticipantListRequiredFields) => {
  const { ref, dimensions } = useElementDimensions();
  const [columns, setColumns] = useState(getColumns(requiredFields, dimensions?.width));

  useEffect(() => {
    if (dimensions?.width) {
      setColumns(getColumns(requiredFields, dimensions.width));
    }
  }, [dimensions?.width]);

  const handleResizeColumn = (newWidth: number, columnIndexes: number[]) => {
    setColumns((prevColumns) => {
      // If resizing spans multiple columns (e.g., header cells with colSpan > 1), divide the new width by the number of columns
      const newWidthPerColumn = columnIndexes.length > 1 ? newWidth / columnIndexes.length : newWidth;
      return prevColumns.map((column, idx) => {
        if (columnIndexes.includes(idx)) {
          return { ...column, width: newWidthPerColumn };
        }
        return column;
      });
    });
  };

  return { ref, columns, handleResizeColumn };
};
